import React, { useState } from 'react';
import hash from 'string-hash';
import { iOS } from './helpers';

export const renderError = ({ input, meta: { touched, error }, ...props }) => (
  <div className={`form__error-outer form__error-outer--${input.name}`}>
    {touched && error && (
      <span role="alert" className={`form__error`}>
        {error}
      </span>
    )}
  </div>
);

export const RenderFieldPassword = ({
  input,
  label,
  placeholder,
  extraClass = '',
  optional,
  strings,
  autoFocus = false,
  meta: { touched, error },
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={`form__field form__field--${input.name} ${extraClass}`}>
      {label && (
        <label className="form__label" htmlFor={input.name}>
          {label}
        </label>
      )}
      {optional && <span>({strings.optional})</span>}
      <input
        className="form__input"
        {...input}
        type={showPassword ? 'text' : 'password'}
        placeholder={placeholder}
        id={input.name}
        autoFocus={autoFocus}
      />
      <button
        className="form__show-password"
        type="button"
        onClick={toggleShowPassword}
      >
        {showPassword ? strings.hidePassword : strings.showPassword}
      </button>
      {touched && error && (
        <span role="alert" className="form__error">
          {error}
        </span>
      )}
    </div>
  );
};

export const renderField = ({
  input,
  label,
  placeholder,
  type,
  extraClass = '',
  optional,
  strings,
  autoFocus = false,
  meta: { touched, error },
}) => (
  <div className={`form__field form__field--${input.name} ${extraClass}`}>
    {label && (
      <label className="form__label" htmlFor={input.name}>
        {label}
      </label>
    )}
    {optional && <span>({strings.optional})</span>}
    <input
      className="form__input"
      {...input}
      placeholder={placeholder}
      type={type}
      id={input.name}
      autoFocus={autoFocus}
    />
    {touched && error && (
      <span role="alert" className="form__error">
        {error}
      </span>
    )}
  </div>
);

export const renderRadioTile = ({
  input,
  label,
  placeholder,
  type,
  extraClass = '',
  autoFocus = false,
  id,
  meta: { touched, error },
}) => (
  <div className={`form__field form__field--${input.name} ${extraClass}`}>
    <input
      className="form__input"
      {...input}
      placeholder={placeholder}
      type={type}
      id={id}
      autoFocus={autoFocus}
    />
    <label className="form__label" htmlFor={id}>
      {label}
    </label>
    {touched && error && (
      <span role="alert" className="form__error">
        {error}
      </span>
    )}
  </div>
);

export const renderDigitField = ({
  input,
  label,
  placeholder,
  type,
  extraClass = '',
  maxLen = 1,
  autoFocus = false,
  meta: { touched, error },
}) => (
  <div
    className={`form__field form__field--pin-digit form__field--${input.name} ${extraClass}`}
  >
    <label className="form__label--hidden" htmlFor={input.name}>
      {label}
    </label>
    <input
      className="form__input"
      {...input}
      placeholder={placeholder}
      type={type}
      id={input.name}
      autoFocus={autoFocus}
      maxLength={maxLen}
      pattern="[0-9]*"
      autoComplete="off"
      aria-label={label}
    />
    {touched && error && (
      <span role="alert" className="form__error">
        {error}
      </span>
    )}
  </div>
);

export const renderCheckBox = ({
  input,
  label,
  type,
  extraClass = '',
  on,
  off,
  meta: { touched, error },
}) => (
  <div
    className={`form__field form__field--${input.name} form__field--${type} ${extraClass}`}
  >
    <input
      className={'form__input form__input--' + type}
      {...input}
      type={type}
      id={input.name}
      data-off-label={off}
      data-on-label={on}
    />
    <label
      htmlFor={input.name}
      className="form__toggle form__label"
      dangerouslySetInnerHTML={{ __html: label }}
    ></label>
    {touched && error && (
      <span role="alert" className="form__error">
        {error}
      </span>
    )}
  </div>
);

export const renderCheckBoxTermsField = ({
  input,
  label,
  type,
  extraClass = '',
  on,
  off,
  meta: { touched, error },
}) => (
  <div
    className={`form__field form__field--${input.name} form__field--${type} ${extraClass}`}
  >
    <input
      className={'form__input form__input--' + type}
      {...input}
      type={type}
      id={input.name}
      data-off-label={off}
      data-on-label={on}
    />
    <label
      htmlFor={input.name}
      className="form__toggle terms__msg"
      dangerouslySetInnerHTML={{ __html: label }}
    ></label>
    {touched && error && (
      <span role="alert" className="form__error">
        {error}
      </span>
    )}
  </div>
);

export const renderCheckBoxTermsFieldComms = ({
  input,
  label,
  type,
  extraClass = '',
  on,
  off,
  isChecked,
  meta: { touched, error },
}) => (
  <div
    className={`form__field form__field--${input.name} form__field--${type} ${extraClass}`}
  >
    <input
      className={'form__input form__input--' + type}
      {...input}
      type={type}
      id={input.name}
      data-off-label={off}
      data-on-label={on}
      checked={isChecked && isChecked === 'Y' ? true : false}
    />
    <label
      htmlFor={input.name}
      className="form__toggle terms__msg"
      dangerouslySetInnerHTML={{ __html: label }}
    ></label>
    {touched && error && (
      <span role="alert" className="form__error">
        {error}
      </span>
    )}
  </div>
);

export const renderSelectField = ({
  input,
  label,
  type,
  extraClass = '',
  optional,
  strings,
  meta: { touched, error },
  children,
}) => (
  <div className={`form__field form__field--${input.name} ${extraClass}`}>
    <label className="form__label" htmlFor={input.name}>
      {label}
    </label>
    {optional && <span>({strings.optional})</span>}
    <select
      className={'form__input form__input--' + type}
      {...input}
      id={input.name}
    >
      {children}
    </select>
    {touched && error && (
      <span role="alert" className="form__error">
        {error}
      </span>
    )}
  </div>
);

export function hashPin(pin) {
  if (pin && pin.length > 0) {
    return String(hash(pin));
  }
  return pin;
}

export function autoTabPin(container) {
  let digits = container.querySelectorAll('.form__input');

  if (iOS()) {
    for (var i = 0; i < digits.length; i++) {
      digits[i].type = 'text';
      digits[i].classList.add('ios-text-mask');
      digits[i].onblur = function () {
        this.type = 'password';
      };
    }
  }

  for (var j = 0; j < digits.length; j++) {
    if (j + 1 < digits.length) {
      digits[j].setAttribute('indexNext', j + 1);
    }

    if (j > 0) {
      digits[j].setAttribute('indexPrev', j - 1);
    }

    digits[j].onkeydown = function (event) {
      let key = event.keyCode || event.charCode;
      if (key === 8 || key === 46) {
        this.setAttribute('currValue', this.value);
      }
    };

    digits[j].onkeyup = function (event) {
      let key = event.keyCode || event.charCode;
      // ignore shift tab and tab
      if (key !== 9 && key !== 16) {
        if (this.value.length === this.maxLength) {
          let nextFocus =
            container.querySelectorAll('.form__input')[
              this.getAttribute('indexNext')
            ];
          if (nextFocus) {
            nextFocus.focus();
          }
        } else if (
          (key === 8 || key === 46) &&
          this.getAttribute('currValue').length === 0
        ) {
          let prevFocus =
            container.querySelectorAll('.form__input')[
              this.getAttribute('indexPrev')
            ];
          if (prevFocus && prevFocus.value.length !== 0) {
            prevFocus.focus();
          }
        }
      }
    };

    digits.onfocus = function () {
      this.setSelectionRange(0, this.value.length);
      if (window.iOS()) this.type = 'text';
    };
  }
}

export function isFuture(dob) {
  const today = new Date();
  const dobDate = Date.parse(dob);

  return dobDate > today;
}

export function daysInMonth(m, y) {
  switch (m) {
    case 1:
      return (y % 4 === 0 && y % 100) || y % 400 === 0 ? 29 : 28;
    case 8:
    case 3:
    case 5:
    case 10:
      return 30;
    default:
      return 31;
  }
}

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export function isValidDate(d, m, y) {
  m = parseInt(m, 10) - 1;
  return (
    isNumeric(m) &&
    m >= 0 &&
    m < 12 &&
    isNumeric(d) &&
    d > 0 &&
    d <= daysInMonth(m, y) &&
    isNumeric(y)
  );
}

export const passwordStrengthFeedback = (strength, strings) => {
  return strings.passwordPolicyFeedback[strength] ? strings.passwordPolicyFeedback[strength] : strings.genericError;
};